<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 25"
    aria-hidden="true"
  >
    <g fill="currentColor">
      <path
        data-name="Path 3112"
        d="M42.483 13.908c-.129-.246-3.23-6.054-8.519-7.142s-10.43 3.02-10.65 3.199a1.249 1.249 0 0 0-.262 1.643 16.551 16.551 0 0 0 6.222 5.468 10.863 10.863 0 0 0 2.401.803c5.224 1.075 10.191-2.215 10.399-2.355a1.249 1.249 0 0 0 .409-1.616Zm-10.091-.16a1.446 1.446 0 0 1 1.009-2.71l.107.05a1.447 1.447 0 0 1 .742 1.814 1.447 1.447 0 0 1-1.857.847Zm-1.86-4.507a3.925 3.925 0 0 0-1.045 5.117 14.307 14.307 0 0 1-3.607-3.15 14.039 14.039 0 0 1 4.652-1.966Zm4.815 6.24a3.919 3.919 0 0 0 1.048-4.908 14.332 14.332 0 0 1 3.248 3.473 14.35 14.35 0 0 1-4.301 1.436Z"
      />
      <path d="m26.842 2.88 2.414-.642.92 3.46-2.414.641z" />
      <path d="m21.407 5.633 2.121-1.32 1.888 3.03-2.12 1.321z" />
      <path d="m37.907 7.322 2.004-2.811 2.034 1.45-2.005 2.811z" />
      <path d="m41.71 10.513 2.643-1.925 1.47 2.019-2.642 1.925z" />
      <path d="m33.585 2.268 2.453.478-.648 3.333-2.453-.477z" />
    </g>
    <g fill="currentColor">
      <path
        d="M20.975 8.876a7.362 7.362 0 0 0-7.249-4.006 7.022 7.022 0 0 0-6.033 5.704 6.816 6.816 0 0 0 3.946 7.35 8.67 8.67 0 0 0 .989.314 2.985 2.985 0 0 1 1.003.386 3.313 3.313 0 0 1 .616 1.09 8.222 8.222 0 0 0 .629 1.247 4.882 4.882 0 0 0 5.773 1.825 4.6 4.6 0 0 0 .578-.283 4.871 4.871 0 0 0 2.174-5.882l-2.523.89a2.14 2.14 0 0 1-3.757 1.997 6.066 6.066 0 0 1-.419-.853 5.385 5.385 0 0 0-1.28-2.018 4.877 4.877 0 0 0-2.084-.979 6.614 6.614 0 0 1-.688-.214 4.2 4.2 0 0 1-2.314-4.438 4.416 4.416 0 0 1 3.704-3.484 4.675 4.675 0 0 1 4.536 2.52Z"
      />
      <path d="m3.981 14.697-.473-2.632 3.21-.577.472 2.632z" />
      <path d="m3.8 9.726.767-2.562 3.114.934-.768 2.561z" />
      <path d="m5.948 5.06 1.957-1.823L10.012 5.5 8.055 7.322z" />
      <path
        d="M18.336 13.403a1.337 1.337 0 0 0 .517-1.878l-.054-.092a6.083 6.083 0 0 0-2.924-2.916 3.6 3.6 0 0 0-4.206 1.354 3.869 3.869 0 0 0-.03 3.89l2.385-1.211a1.3 1.3 0 0 1-.113-1.219.914.914 0 0 1 1.063-.295 2.416 2.416 0 0 1 1 .93 2.953 2.953 0 0 0-.613 2.087 3.225 3.225 0 0 0 2.177 2.722 3.449 3.449 0 0 0 2.782-.306 3.384 3.384 0 0 0 .52-.37l-1.747-2.024a.773.773 0 0 1-.704.16.564.564 0 0 1-.362-.425c-.03-.21.229-.364.31-.407Z"
      />
    </g>
  </svg>
</template>
